import React, { use, useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { NavLink, useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Form,
    Modal,
    ModalBody,
    Input,
    FormGroup,
    ModalHeader,
    Button,
    Label,
    FormFeedback,
    Row,
    Col,
    Nav,
    NavItem,
    TabContent,
    TabPane,
} from "reactstrap"
import * as Yup from "yup"
import Flatpickr from "react-flatpickr";

import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Select from "react-select";
import { dateFormat, formatDateToISO } from "pages/Common"
import DeleteModel from "common/deleteModel/deleteModel"
import ErrorModel from "common/errorModel/errorModel"
import { exportDataExcel } from "components/Common/ExportData"
import { routes } from "routes/path"
import RentListTable from "./RentListTable"
import RentMakingFormTable from "./RentMakingFormTable"
import classNames from "classnames"
import MakingListTable from "./MakingListTable"
import CountListTable from "./CountListTable"
import { GetObjByUnBillsRentMakingStatus, MsgColors, UnBillsRentMakingStatus } from "_mock/Static_data"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

let TodaysPending = false
let WhatsAppMSG = []
let whatsAppMessages = []
const UnbillList = () => {
    document.title = `Rent & Making | Raja Rani Couture`
    let { pathname } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const { state } = useLocation()
    const navigate = useNavigate()

    // useStates
    const [modal, setModal] = useState(false)
    const [RentTableData, setRentTableData] = useState([])
    const [UnBillRentStatusCountList, setUnBillRentStatusCountList] = useState([])
    const [CountTableData, setCountTableData] = useState([])
    const [MakingTableData, setMakingTableData] = useState([])
    // const [whatsAppMessages, setWhatsAppMessages] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [totalCounts, setTotalCounts] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    // filter data for Unbill Rent, Making, Count
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }
    const [userFilter, setUserFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(true)
    const [customActiveTab, setcustomActiveTab] = useState(state?.tab ? state?.tab : "1")
    const [statusFilter, setStatusFilter] = useState(0)
    const [customerData, setCustomerData] = useState({
        CustomerName: '',
        ContactNo: '',
    })
    const [iswhatsAppMsgAllSend, setIswhatsAppMsgAllSend] = useState(true)
    const [isPending, setIsPending] = useState(state?.Call ? false : true)
    const [isCall, setIsCall] = useState(state?.Call || false)

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // Unbill Rent, Making, Count list api
    const MakingListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("unbill/making/list", {
            UserId: userFilter,
            Status: parseInt(statusFilter),
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
        }).then(({ data, status }) => {
            if (status === 200) {
                setMakingTableData(data.MakingList)
                setTotalRecords(data.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    const RentListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("unbill/rent/list", {
            UserId: userFilter,
            Status: parseInt(statusFilter),
            Call: isCall,
            TodaysPending: isPending,
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
        }).then(({ data, status }) => {
            if (status === 200) {
                setRentTableData(data.UnbillRentList || [])
                setUnBillRentStatusCountList(data.UnBillRentStatusCountList || [])
                setTotalRecords(data.TotoalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    const CountListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("unbill/count/list", {
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
        }).then(({ data, status }) => {
            if (status === 200) {
                setCountTableData(data.CountList)
                setTotalRecords(data.TotalRecords)
                setTotalCounts(data.TotalCounts)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // Unbill Rent, Making, Count list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined) {
            if (customActiveTab == "1") {
                RentListApi()
            }
            else if (customActiveTab == "2") {
                MakingListApi()
            } else {
                CountListApi()
            }
        }
    }, [searchText, displayStart, rowsPerPage, userFilter, dateFilter, dateDisble, customActiveTab, statusFilter, isPending, isCall])


    // Create Unbill Rent, Making, Count handler
    const handleRentMakingClick = () => {
        navigate(routes.rentmakingcreate, {
            state: {
                tab: customActiveTab,
            },
        })
    }

    // popup box handler
    const toggle = () => {
        setModal(!modal)
        // validation.handleReset()
    }

    const handleWhatsApp = (data) => {
        // Replace placeholders in original message
        let message = data?.WhatsAppMsg
            .replaceAll("{CUSTOMER_NAME}", customerData?.CustomerName || "")
            .replaceAll("{CUSTOMER_CONTACTNO}", customerData?.ContactNo || "");

        // const url = `https://api.whatsapp.com/send?phone=91${customerData?.ContactNo}&text=${encodeURIComponent(message)}`
        // window.open(url, "_blank", "width=1000,height=600,menubar=no,toolbar=no");
        window.open(
            `https://api.whatsapp.com/send?phone=91${customerData?.ContactNo}&text=${encodeURIComponent(message)}`,
            "_blank",
            "width=1000,height=600,menubar=no,toolbar=no"
        );
    };

    // whatsApp send message
    const handleStatusChange = (data, status, type) => {
        DeleteModel.confirmDeleteInquiry({
            title: "Are you sure? ",
            text: "You want to change this status? ",
            isMobile,
        }).then(response => {
            if (response == true) {
                putApi("Unbill/status-change", {
                    Id: data.Id,
                    Status: parseInt(status),
                    Type: type,
                }).then(({ data, status }) => {
                    if (status == 200) {
                        if (type == 1) {
                            RentListApi()
                        } else {
                            MakingListApi()
                        }
                        toast.success("successfully updated", {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    } else {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    }
                })
            } else {
                setIsLoading(false)
            }
        })
    }

    // whatsApp messgaes Modal
    const handleWhatsAppMessages = (data, Type) => {
        setCustomerData({
            CustomerName: data.Name,
            ContactNo: data.ContactNo,
        })
        if (data?.Id) {
            postApi(`Unbill/whatsapp-msg`, {
                UnbillId: data?.Id,
                Type: Type
            }).then(({ data, status }) => {
                if (status === 200) {
                    const WhatsAppMSG = data.map((item, index) => {
                        const msgBgColor = MsgColors[index % MsgColors.length].Value;
                        return {
                            CreatedByName: item.CreatedByName,
                            CreatedOn: item.CreatedOn,
                            Date: item.Date,
                            Id: item.Id,
                            IsSend: item.IsSend == true ? true : false,
                            Type: item.Type,
                            WhatsAppMsg: item.WhatsAppMsg,
                            WhatsAppMsgId: item.WhatsAppMsgId,
                            Disabled: item.IsSend == true ? true : false,
                            BgColor: msgBgColor,
                        };
                    });
                    whatsAppMessages = (WhatsAppMSG)
                    const allSent = data.every(item => item.IsSend === true);
                    setIswhatsAppMsgAllSend(allSent);

                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
        }
        toggle()
    }

    // Edit Rent
    const handleEditRent = (data) => {
        navigate(routes.rentmakingupdate, {
            state: {
                tab: "1",
                isEdit: true,
                data
            },
        })
    }

    // Delete Rent
    const handleDeleteRent = (Id) => {
        setIsLoading(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this rent permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`unbill/rent/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = RentTableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setRentTableData(updatedArray)
                                RentListApi()
                                toast.success("Rent deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Rent",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }

    }

    // Export Excel Rent
    function writeDataToExcelRent() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Card No.", "Name", "ContactNo", "Category", "Occasion Date", "Status", "City", "Attend By", "Created On", "Remark"];
            const mainTitle = "Unbill Rent";
            const widthObj = [
                {
                    Key: "A",
                    Value: 12,
                },
                {
                    Key: "B",
                    Value: 20,
                },
                {
                    Key: "C",
                    Value: 13,
                },
                {
                    Key: "D",
                    Value: 15,
                },
                {
                    Key: "E",
                    Value: 12,
                },
                {
                    Key: "F",
                    Value: 12,
                },
                {
                    Key: "G",
                    Value: 18,
                },
                {
                    Key: "H",
                    Value: 20,
                },
                {
                    Key: "I",
                    Value: 13,
                },
                {
                    Key: "J",
                    Value: 30,
                },
            ]
            const extention = "Unbill_rent.xlsx"
            let excelSheetData = []

            postApi("unbill/rent/list", {
                UserId: userFilter,
                Status: parseInt(statusFilter),
                Call: isCall,
                TodaysPending: isPending,
                displayStart: displayStart,
                pageSize: 100000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.UnbillRentList?.length; index++) {
                        let dataObj = {
                            CardNo: data?.UnbillRentList[index].CardNo,
                            Name: data?.UnbillRentList[index].Name,
                            ContactNo: data?.UnbillRentList[index].ContactNo,
                            Category: data?.UnbillRentList[index].CategoryName,
                            OccasionDate: data?.UnbillRentList[index].OccasionDate == null
                                ? "N/A"
                                : dateFormat(data?.UnbillRentList[index].OccasionDate, "dd-MM-yyyy"),
                            Status: GetObjByUnBillsRentMakingStatus(data?.UnbillRentList[index].Status)[0].Key,
                            City: data?.UnbillRentList[index].City,
                            AttendBy: data?.UnbillRentList[index].AttendByName,
                            CreatedOn: data?.UnbillRentList[index].CreatedOn == null
                                ? "N/A"
                                : dateFormat(data?.UnbillRentList[index].CreatedOn, "dd-MM-yyyy"),
                            Remark: data?.UnbillRentList[index].Remark == '' ? "N/A" : data?.UnbillRentList[index].Remark,
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention, data?.TotalCounts)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })

            setIsLoading(false)
        }
    }


    // Unbill Rent Colum
    const rentColumns = useMemo(
        () => [
            {
                Header: "Card No.",
                accessor: "CardNo",
                width: "5%",
            },
            {
                Header: "Customer Name",
                accessor: "Name",
            },
            {
                Header: "Contact#",
                accessor: "ContactNo",
                width: "8%"
            },
            {
                Header: "Category",
                accessor: "CategoryName",
                width: "9%"
            },
            {
                Header: "Occasion Date",
                accessor: "OccasionDate",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.OccasionDate == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.OccasionDate.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "City",
                accessor: "City",
                width: "6%"
            },
            {
                Header: "Status",
                accessor: "Status",
                width: "10%",
                Cell: ({ row }) => (
                    <div>
                        <Input
                            // disabled={handleByValue == 0}
                            type="select"
                            bsSize="sm"
                            id="validationCustom01"
                            className="form-control-sm"
                            name="leadType"
                            style={{ width: "100px" }}
                            // onChange={validation.handleChange}
                            onChange={e => {
                                handleStatusChange(row.original, e.target.value, 1)
                            }}
                            value={row.original.Status}
                        >
                            {UnBillsRentMakingStatus.map((item, index) => {
                                return (
                                    <option key={index} value={item.Value}>
                                        {item.Key}
                                    </option>
                                )
                            })}
                        </Input>
                    </div>
                )
            },
            {
                Header: "Attend By",
                accessor: "AttendByName",
                width: "8%"
            },
            {
                Header: "Created By",
                accessor: "CreatedByName",
                width: "8%"
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "8%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.CreatedOn.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Remark",
                accessor: "Remark",
                width: "7%",
                disableSorting: true,
                Cell: ({ row }) => (
                    <p
                        className="mb-0"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={`${row.original.Remark == null ? '' : row.original.Remark}`}
                    >
                        {row.original.Remark.length > 15
                            ? `${row.original.Remark.substr(0, 15)}...`
                            : row.original.Remark == ""
                                ? "N/A"
                                : row.original.Remark}
                    </p>
                ),
            },
            {
                Header: "Action",
                width: "9%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            <li className="mytooltip">
                                <i
                                    className="fs-5 fab fa-whatsapp"
                                    id={`edittooltip${row.original.Id}`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleWhatsAppMessages(row.original, 1)}
                                ></i>
                                <span className="mytext">WhatsApp</span>
                            </li>
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEditRent(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>


                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDeleteRent(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [RentTableData]
    )

    // Edit Count
    const handleEditCount = (data) => {
        navigate(routes.rentmakingupdate, {
            state: {
                tab: "3",
                isEdit: true,
                data
            },
        })
    }

    // Delete Count
    const handleDeleteCount = (Id) => {
        setIsLoading(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this count permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`unbill/count/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = CountTableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setCountTableData(updatedArray)
                                CountListApi()
                                toast.success("Count deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Count",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }

    }

    // Export Excel Count
    function writeDataToExcelCount() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Date", "Count"];
            const mainTitle = "UnBill Count";
            const widthObj = [{
                Key: "A",
                Value: 18,
            },
            {
                Key: "B",
                Value: 12,
            },
            ]
            const extention = "UnBill_Count.xlsx"
            let excelSheetData = []

            postApi("unbill/count/list", {
                displayStart: displayStart,
                pageSize: 100000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.CountList.length; index++) {
                        let dataObj = {
                            Date: data?.CountList[index].Date == null
                                ? "N/A"
                                : dateFormat(data?.CountList[index].Date, "dd-MM-yyyy"),
                            Count: data?.CountList[index].Count,
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention, data?.TotalCounts)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })

            setIsLoading(false)
        }
    }

    // Edit Making
    const handleEditMaking = (data) => {
        navigate(routes.rentmakingupdate, {
            state: {
                tab: "2",
                isEdit: true,
                data
            },
        })
    }

    // Delete Making
    const handleDeleteMaking = (Id) => {
        setIsLoading(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this makinng permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`unbill/making/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = MakingTableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setMakingTableData(updatedArray)
                                MakingListApi()
                                toast.success("Making deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Making",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }

    }

    // Export Excel Making
    function writeDataToExcelMaking() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Name", "ContactNo", "Inquiry Date", "Category", "Occasion Date", "Status", "City", "Attend By"];
            const mainTitle = "Unbill Making";
            const widthObj = [{
                Key: "A",
                Value: 20,
            },
            {
                Key: "B",
                Value: 15,
            },
            {
                Key: "C",
                Value: 13,
            },
            {
                Key: "D",
                Value: 15,
            },
            {
                Key: "E",
                Value: 13,
            },
            {
                Key: "F",
                Value: 10,
            },
            {
                Key: "G",
                Value: 20,
            },
            {
                Key: "H",
                Value: 20,
            },
            ]
            const extention = "Unbill_Making.xlsx"
            let excelSheetData = []

            postApi("unbill/making/list", {
                UserId: userFilter,
                Status: parseInt(statusFilter),
                displayStart: displayStart,
                pageSize: 100000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.MakingList.length; index++) {
                        let dataObj = {
                            Name: data?.MakingList[index].Name,
                            ContactNo: data?.MakingList[index].ContactNo,
                            InquiryDate: data?.MakingList[index].InquiryDate == null
                                ? "N/A"
                                : dateFormat(data?.MakingList[index].InquiryDate, "dd-MM-yyyy"),
                            Category: data?.MakingList[index].CategoryName,
                            OccasionDate: data?.MakingList[index].OccasionDate == null
                                ? "N/A"
                                : dateFormat(data?.MakingList[index].OccasionDate, "dd-MM-yyyy"),
                            Status: GetObjByUnBillsRentMakingStatus(data?.MakingList[index].Status)[0].Key,
                            City: data?.MakingList[index].City,
                            AttendBy: data?.MakingList[index].AttendByName,
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention, data?.TotalCounts)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })

            setIsLoading(false)
        }
    }

    // Unbill Making Column
    const makingColumns = useMemo(
        () => [
            {
                Header: "Customer Name",
                accessor: "Name",
            },
            {
                Header: "Contact#",
                accessor: "ContactNo",
                width: "8%"
            },
            {
                Header: "Inquiry Date",
                accessor: "InquiryDate",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.InquiryDate == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.InquiryDate.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Category",
                accessor: "CategoryName",
                width: "9%"
            },
            {
                Header: "Occasion Date",
                accessor: "OccasionDate",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.OccasionDate == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.OccasionDate.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "City",
                accessor: "City",
                width: "6%"
            },
            {
                Header: "Attend By",
                accessor: "AttendByName",
                width: "8%"
            },
            {
                Header: "Created By",
                accessor: "CreatedByName",
                width: "8%"
            },
            {
                Header: "Status",
                accessor: "Status",
                width: "12%",
                Cell: ({ row }) => (
                    <div>
                        <Input
                            // disabled={handleByValue == 0}
                            type="select"
                            bsSize="sm"
                            id="validationCustom01"
                            className="form-control-sm"
                            name="leadType"
                             style={{ width: "100px" }}
                            // onChange={validation.handleChange}
                            onChange={e => {
                                handleStatusChange(row.original, e.target.value, 2)
                            }}
                            value={row.original.Status}
                        >
                            {UnBillsRentMakingStatus.map((item, index) => {
                                return (
                                    <option key={index} value={item.Value}>
                                        {item.Key}
                                    </option>
                                )
                            })}
                        </Input>
                    </div>
                )
            },
            {
                Header: "Action",
                width: "8%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            <li className="mytooltip">
                                <i
                                    className="fs-5 fab fa-whatsapp"
                                    id={`edittooltip${row.original.Id}`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleWhatsAppMessages(row.original, 2)}
                                ></i>
                                <span className="mytext">WhatsApp</span>
                            </li>
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEditMaking(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>


                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDeleteMaking(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [MakingTableData]
    )

    // Unbill Count Coumn
    const countColumns = useMemo(
        () => [
            {
                Header: "Date",
                accessor: "Date",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.Date == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.Date?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Count",
                accessor: "Count",
            },
            // {
            //     Header: "Created On",
            //     accessor: "CreatedOn",
            //     width: "8%",
            //     Cell: ({ row }) => (
            //         <p className=" mb-0">
            //             {row.original?.CreatedOn == "0001-01-01T00:00:00"
            //                 ? "N/A"
            //                 : dateFormat(row.original?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
            //         </p>
            //     ),
            // },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "8%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            {/* <li className="mytooltip">
                                <i
                                    className="fs-5 fab fa-whatsapp"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleWhatsApp(row.original)}
                                ></i>
                                <span className="mytext">WhatsApp</span>
                            </li> */}
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEditCount(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>


                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDeleteCount(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [CountTableData]
    )

    const handleWhatsAppMsgChanges = (data, IsSend, Date, field) => {
        whatsAppMessages.forEach(function (item) {
            if (item?.Id === data?.Id) {
                item.IsSend = IsSend,
                    item.Date = IsSend ? Date : (field == "Date" ? formatDateToISO(Date) : Date)
            }
        });
    }

    const handleSaveWhatsAppMsgChanges = () => {
        setformSumitLoading(true)
        const selectedWhatsAppMessages = whatsAppMessages.map(({ Id, IsSend, Date }) => ({
            Id,
            IsSend,
            Date
        }));
        putApi("Unbill/whatsapp-msg/update", selectedWhatsAppMessages).then(({ data, status }) => {
            if (status == 200) {
                setformSumitLoading(false)
                toast.success("successfully updated", {
                    style: {
                        fontSize: "15px",
                    },
                })
                setModal(false)
                if (customActiveTab == "1") {
                    RentListApi()
                } else {
                    MakingListApi()
                }
            } else {
                setformSumitLoading(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

    }

    // WhatsApp Message Column
    const MessageColumn = useMemo(
        () => [
            {
                accessor: "Id",
                disableSorting: true,
                width: "4%",
                Cell: ({ row }) => {
                    const { IsSend, Disabled } = row.original;
                    return (
                        <input
                            type="checkbox"
                            disabled={Disabled}
                            className="form-check-input"
                            defaultChecked={IsSend}
                            onChange={(e) => handleWhatsAppMsgChanges(row.original, e.target.checked, row.original.Date, "Send")}
                        />
                    );
                }
            },
            {
                Header: "Date",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Date
                    </div>
                ),
                accessor: "Date",
                width: "25%",
                Cell: ({ row }) => (
                    <div className="d-flex date-after" >
                        <Flatpickr
                            disabled={row.original.Disabled}
                            className="form-control d-block flatpicker-date"
                            placeholder="dd-MM-yyyy"
                            options={{
                                // enableTime: true,
                                dateFormat: "d-m-Y",
                                disableMobile: true
                            }}
                            value={dateFormat(row.original.Date, "dd-MM-yyyy")}
                            onChange={(e) =>
                                handleWhatsAppMsgChanges(row.original, row.original.IsSend, e, "Date")
                            }
                        />
                    </div>
                ),
            },
            {
                Header: "Message",
                accessor: "WhatsAppMsg",
                Cell: ({ row }) => (
                    <>
                        <div className="text-wrap">
                            {row.original.WhatsAppMsg}
                        </div>
                    </>
                )
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "8%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            {row.original.IsSend && row.original.Disabled ?
                                <li className="mytooltip">
                                    <i
                                        className="fs-5 fab fa-whatsapp"
                                        id={`edittooltip${row.original.Id}`}
                                        style={{ cursor: "not-allowed" }}
                                    ></i>
                                    <span className="mytext">WhatsApp</span>
                                </li>
                                :
                                <li className="mytooltip">
                                    <i
                                        className="fs-5 fab fa-whatsapp"
                                        id={`edittooltip${row.original.Id}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleWhatsApp(row.original)}
                                    ></i>
                                    <span className="mytext">WhatsApp</span>
                                </li>
                            }

                        </ul>
                    )
                },
            },
        ],
        [WhatsAppMSG, whatsAppMessages]
    )

    const toggleCustom = tab => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab)
            setDisplayStart(1)
            setRowsPerPage(20)
            setSearchText('')
            setDateFilter([new Date(), new Date()])
            setStatusFilter(0)
            setUserFilter(0)
            setdateDisble(true)
        }
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />

                <Card>
                    <CardBody>
                        <Row>
                            <Col md={12}>
                                <Nav
                                    tabs
                                    className="nav-tabs-custom nav-justified"
                                    style={{ padding: "2px 10px" }}
                                >
                                    <NavItem
                                        onClick={() => {
                                            toggleCustom("1")
                                        }}
                                    >
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classNames({
                                                "active nav-link": customActiveTab === "1",
                                            })}
                                        >
                                            <span className="d-block d-sm-none">
                                                <i className="fas fa-calendar-check"></i>
                                            </span>
                                            <span className="d-none d-sm-block">
                                                Rent
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem
                                        onClick={() => {
                                            toggleCustom("2")
                                        }}
                                    >
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classNames({
                                                "active nav-link": customActiveTab === "2",
                                            })}
                                        >
                                            <span className="d-block d-sm-none">
                                                <i className="fas fa-shopping-cart"></i>
                                            </span>
                                            <span className="d-none d-sm-block">Making</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem
                                        onClick={() => {
                                            toggleCustom("3")
                                        }}
                                    >
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classNames({
                                                "active nav-link": customActiveTab === "3",
                                            })}
                                        >
                                            <span className="d-block d-sm-none">
                                                <i className="fas fa-shopping-cart"></i>
                                            </span>
                                            <span className="d-none d-sm-block">Count</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>
                        <TabContent activeTab={customActiveTab} className="p-3 text-muted">
                            <TabPane tabId="1">
                                {customActiveTab == "1" &&
                                    <RentListTable
                                        columns={rentColumns}
                                        data={RentTableData}
                                        isGlobalFilter={true}
                                        isAddMakingList={true}
                                        handleRentMakingClick={handleRentMakingClick}
                                        customPageSize={10}
                                        className="custom-header-css"
                                        filterData={filterData}
                                        isLoading={isLoading}
                                        TotalRecords={totalRecords}
                                        pagePerSize={pagePerSize}
                                        setDateFilter={setDateFilter}
                                        dateFilter={dateFilter}
                                        users={users}
                                        userFilter={userFilter}
                                        setUserFilter={setUserFilter}
                                        setdateDisble={setdateDisble}
                                        dateDisble={dateDisble}
                                        writeDataToExcel={writeDataToExcelRent}
                                        setStatusFilter={setStatusFilter}
                                        statusFilter={statusFilter}
                                        setIsCall={setIsCall}
                                        isCall={isCall}
                                        setIsPending={setIsPending}
                                        isPending={isPending}
                                        TodaysPending={TodaysPending}
                                        UnBillRentStatusCountList={UnBillRentStatusCountList}
                                    />
                                }
                            </TabPane>
                            <TabPane tabId="2">
                                {customActiveTab == "2" &&
                                    <MakingListTable
                                        columns={makingColumns}
                                        data={MakingTableData}
                                        isGlobalFilter={true}
                                        isAddMakingList={true}
                                        handleRentMakingClick={handleRentMakingClick}
                                        customPageSize={10}
                                        className="custom-header-css"
                                        filterData={filterData}
                                        isLoading={isLoading}
                                        TotalRecords={totalRecords}
                                        pagePerSize={pagePerSize}
                                        setDateFilter={setDateFilter}
                                        dateFilter={dateFilter}
                                        users={users}
                                        userFilter={userFilter}
                                        setUserFilter={setUserFilter}
                                        setdateDisble={setdateDisble}
                                        dateDisble={dateDisble}
                                        writeDataToExcel={writeDataToExcelMaking}
                                        setStatusFilter={setStatusFilter}
                                        statusFilter={statusFilter}
                                    />
                                }
                            </TabPane>
                            <TabPane tabId="3">
                                {customActiveTab == "3" &&
                                    <CountListTable
                                        columns={countColumns}
                                        data={CountTableData}
                                        isGlobalFilter={true}
                                        isAddMakingList={true}
                                        handleRentMakingClick={handleRentMakingClick}
                                        customPageSize={10}
                                        className="custom-header-css"
                                        filterData={filterData}
                                        isLoading={isLoading}
                                        TotalRecords={totalRecords}
                                        pagePerSize={pagePerSize}
                                        setDateFilter={setDateFilter}
                                        dateFilter={dateFilter}
                                        users={users}
                                        userFilter={userFilter}
                                        setUserFilter={setUserFilter}
                                        setdateDisble={setdateDisble}
                                        dateDisble={dateDisble}
                                        writeDataToExcel={writeDataToExcelCount}
                                        totalCounts={totalCounts}
                                    />
                                }
                            </TabPane>
                        </TabContent>

                        <Modal
                            isOpen={modal}
                            toggle={toggle}
                            centered={true}
                            size="defalt"
                        // style={{ width: !isMobile ? "500px" : "" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={toggle} tag="h5">
                                    Send Message
                                </ModalHeader>
                                <ModalBody>
                                    <Row className='mt-1'>
                                        <RentMakingFormTable
                                            columns={MessageColumn}
                                            data={whatsAppMessages}
                                            customPageSize={10}
                                            className="custom-header-css"
                                            isLoading={isLoading}
                                        />
                                    </Row>
                                    {!iswhatsAppMsgAllSend &&
                                        <div className="text-end">
                                            {formSumitLoading ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    className="btn btn-primary btn-sm "
                                                    type="button"
                                                    onClick={() => handleSaveWhatsAppMsgChanges()}
                                                >
                                                    Save
                                                </Button>
                                            )}
                                        </div>
                                    }
                                </ModalBody>
                            </div>
                        </Modal >

                    </CardBody>
                </Card>
            </div>
        </div>
    )
}

export default UnbillList